var _mask, _path, _path2, _path3, _path4, _path5, _path6, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgButton212Disabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 91,
    viewBox: "0 0 212 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0_bow_button_212",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 12,
    width: 201,
    height: 79
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.7986 13.4477C75.2884 15.4813 136.089 13.8174 163.6 12.3384C185.952 11.2292 193.785 12.7082 198.561 31.1958C201.236 41.5489 199.708 65.2131 197.797 72.9779C195.505 81.6671 188.436 89.6167 168.376 89.247C150.227 88.8772 83.1213 88.6924 35.933 89.9865C3.83725 91.0958 3.45516 79.8183 1.73574 73.3476C0.0163301 66.8769 -0.938899 40.6245 1.35365 33.0446C7.27607 14.9267 25.9986 12.7082 38.7986 13.4477Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_bow_button_212)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1.00024 12.062H199.443L202 90.062H-0.511617L-1.00024 12.062Z",
    fill: "url(#paint0_linear_bow_button_212)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68259 85.78C-1.5 77.5 -9.43244e-06 59.5 -1.81645e-05 48.3843L37.5216 14.5014C55.7507 14.3599 73.0007 14.201 88.5216 14.0306L8.68259 85.78Z",
    fill: "url(#paint1_linear_bow_button_212)",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0452 89C78.6069 88.9793 61.5481 89.7802 43.5552 89.7757L127.91 13.5115C143.571 13.2568 154.678 12.9917 159.331 12.7315C167.422 12.3139 173.829 12.2085 178.978 12.9729L94.0452 89Z",
    fill: "url(#paint2_linear_bow_button_212)",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M173.726 89.094C170.067 89.0165 152.674 89.0551 132.837 89L198.217 32.5825C198.424 33.3247 198.626 34.0928 198.823 34.8877C201 62.5 203 89 173.726 89.094Z",
    fill: "url(#paint3_linear_bow_button_212)",
    fillOpacity: 0.5
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000244141 18.0626C-0.000244141 14.7489 2.68605 12.0626 5.99976 12.0626H194C197.313 12.0626 200 14.7489 200 18.0626V84.0626C200 87.3763 197.313 90.0626 194 90.0626H5.99975C2.68604 90.0626 -0.000244141 87.3763 -0.000244141 84.0626V18.0626Z",
    fill: "url(#paint4_linear_bow_button_212)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.521 23.9993C12.172 25.9974 11.882 29.812 12.027 31.0835C12.172 32.355 14.6364 32.5367 18.1156 31.8101C21.5948 31.0835 23.9143 29.4487 23.1894 26.724C22.3196 22.7278 19.1304 22.9094 16.521 23.9993ZM26.0888 27.4506C26.8136 20.9113 29.8579 20.548 42.1801 22.5461C56.3868 24.9075 61.6056 24.7259 61.7506 25.9974C62.0405 28.1772 54.2123 28.3588 44.6445 28.3588C35.0767 28.3588 25.7988 29.812 26.0888 27.4506Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_bow_button_212",
    x1: 106,
    y1: 0.633423,
    x2: 106,
    y2: 78.6334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACC7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#738CA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_bow_button_212",
    x1: -25.5866,
    y1: -1.02185,
    x2: -25.5866,
    y2: 90.4264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_bow_button_212",
    x1: -25.5866,
    y1: -1.02185,
    x2: -25.5866,
    y2: 90.4264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_bow_button_212",
    x1: -25.5866,
    y1: -1.02185,
    x2: -25.5866,
    y2: 90.4264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_bow_button_212",
    x1: 205.482,
    y1: -3.70577,
    x2: 124.645,
    y2: 32.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C7895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C7895",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton212Disabled);
export default __webpack_public_path__ + "static/media/button-212-disabled.fcc2452f.svg";
export { ForwardRef as ReactComponent };